
import axios, { AxiosInstance } from 'axios';

const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || '';

class API {
    public api: AxiosInstance;
    constructor() {
        this.api = axios.create({
            baseURL: BACKEND_URL, 
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    
    private getAuthHeaders = () => ({
        Authorization: `${localStorage.getItem('hash')}`,
        Userdata: localStorage.getItem('initDataRow'),
    });
    
    public fetchData = async (endpoint: string) => {
        try {
            const response = await this.api.get(endpoint, {
                headers: this.getAuthHeaders(),
            });
            return response.data;
        } catch (error) {
            console.error('API hiba:', error);
            throw error;
        }
    };

    public postData = async (endpoint: string, data: unknown) => {
        try {
            console.log(data);
            const response = await this.api.post(endpoint, data, {
                headers: this.getAuthHeaders(),
            });
            return response.data;
        } catch (error) {
            console.error('API hiba:', error);
            throw error;
        }
    };
}

let _instance: API;
export default function getAPI(): API {
    if (!_instance) { _instance = new API(); console.log('initialize new API singleton...') };
    return _instance;
}